export default {"src":"/_next/static/media/mondial-logotype-full-color-rgb.d58bc9db.svg","height":450,"width":450,"blurWidth":0,"blurHeight":0};